export default function checkAppPermission(permission, app) {
  const appPermissions = this.user.permissions.appPermissions;
  const thePerm = appPermissions[permission];
  if (!thePerm) return false;
  const hasForApp = thePerm.apps.includes(app);
  return hasForApp || thePerm.forAll;
}
